<template>
    <div>
        <van-dialog
                :title="title"
                v-model="show"
                confirm-button-text="关闭">
            <van-cell-group style="max-height:440px;overflow: auto">
                <van-cell v-for="(item,index) in list" :key="index" :title="item.title" :value="item.value" />
            </van-cell-group>
        </van-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    export default{
        data(){
            return {
                show:false,
            }
        },
        props:['title','list']
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/mobile/components/ShowInfo.vue